// Generated by genversion.
export const version = '5.1055.17';
